import { defineComponent as _defineComponent } from 'vue'
import { Beneficiary } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import { ref, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentEditorCancelModal',
  props: {
  beneficiary: {
    type: Object as PropType<Beneficiary>,
    required: true,
  },
},
  emits: ["cancel-payment"],
  setup(__props, { emit }: { emit: ({
  (e: 'cancel-payment'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const paymentEditorCancelModal = ref<InstanceType<typeof BModal> | null>(null);





function showModal() {
  paymentEditorCancelModal.value!.show();
}

function hideModal() {
  paymentEditorCancelModal.value!.hide();
}

return { __sfc: true,paymentEditorCancelModal, emit, props, showModal, hideModal, BModal }
}

})